(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire0d69"];
var parcelRegister = parcelRequire.register;
parcelRegister("4XT8J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39d771b8cdf0ac27$export$2e2bcd8739ae039; });
var $39d771b8cdf0ac27$var$webpageDownload = function() {
    var pdfButton;
    var initialText;
    var generatingPDF = false;
    $(".html-to-pdf").click(function() {
        if (generatingPDF === false) {
            generatingPDF = true;
            pdfButton = $(this);
            initialText = pdfButton.html();
            pdfButton.html("Generating...");
            var filename = $(this).data("filename");
            var pdf_url = window.location.href.split("?")[0] + "?print=1";
            var prod = "api_public_a30195b1ab6544e38192af40c9aa11b1";
            var staging = "api_public_b36ef9a4a4c24dd19ba259087032b90c";
            SejdaJsApi.htmlToPdf({
                filename: filename + ".pdf",
                pageSize: "a4",
                pageOrientation: "portrait",
                publishableKey: prod,
                pageMargin: 20.2,
                pageMarginUnits: "px",
                url: pdf_url,
                always: function always() {
                    pdfButton.html(initialText);
                    generatingPDF = false;
                }
            });
        }
    });
};
var $39d771b8cdf0ac27$export$2e2bcd8739ae039 = $39d771b8cdf0ac27$var$webpageDownload;

});

})();
//# sourceMappingURL=webpage-download.eb09ad03.js.map
